import script from "./SelectPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SelectPanel.vue?vue&type=style&index=0&id=53480b32&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53480b32"]])

export default __exports__